import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Reusable Components
import CircularPhotoCard from "reusables/Cards/CircularPhotoCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import kitchen from "assets/images/Services/OneOff/kitchen1.jpg";
import bathroom from "assets/images/Services/OneOff/bathroom1.jpg";
import livingBedroom from "assets/images/Services/OneOff/living-bedroom1.jpg";
import hallwaysEntry from "assets/images/Services/OneOff/hallways-entry1.jpg";
import general1 from "assets/images/Services/OneOff/general1.jpg";

// Data for One-Off Cleaning Services
const cleaningCategories = [
  {
    image: general1,
    name: "General Cleaning",
    position: { color: "info", label: "" },
    description: [
      "Dusting and wiping down all surfaces, including furniture and baseboards",
      "Vacuuming or mopping floors",
      "Cleaning interior windows, sills, and frames",
    ],
  },
  {
    image: kitchen,
    name: "Kitchen Cleaning",
    position: { color: "info", label: "" },
    description: [
      "Degreasing and cleaning stovetops, countertops, and backsplashes",
      "Cleaning and disinfecting sinks and faucets",
      "Wiping down appliances and cabinet exteriors",
    ],
  },
  {
    image: bathroom,
    name: "Bathroom Cleaning",
    position: { color: "info", label: "" },
    description: [
      "Scrubbing and disinfecting toilets, sinks, and bathtubs",
      "Polishing mirrors and chrome fixtures",
      "Removing soap scum and limescale from tiles and surfaces",
    ],
  },
  {
    image: livingBedroom,
    name: "Bedrooms and Living Areas",
    position: { color: "info", label: "" },
    description: [
      "Dusting shelves, light fixtures, and décor items",
      "Tidying and arranging furniture for a neat appearance",
      "Vacuuming carpets and rugs or mopping hard floors",
    ],
  },
  {
    image: hallwaysEntry,
    name: "Entryways and Hallways",
    position: { color: "info", label: "" },
    description: [
      "Cleaning door handles, light switches, and skirting boards",
      "Vacuuming or mopping floors for a clean and welcoming look",
    ],
  },
];

function OneOff_Section2() {
  return (
    <Container>
      <Grid container direction="column" sx={{ mx: "auto" }} width="100%">
        <Grid item>
          <SubTitleContents
            title="What’s Included in Our One-Off Cleaning Services?"
            contents="Our detailed checklist ensures every corner of your space is spotless:"
          />
        </Grid>
        <Grid item mt={5} width="100%">
          <Grid container spacing={3}>
            {cleaningCategories.map((category, index) => (
              <Grid item xs={12} lg={6} key={index}>
                <MKBox mb={1} height="100%">
                  <CircularPhotoCard
                    image={category.image}
                    icon="check"
                    name={category.name}
                    position={category.position}
                    description={category.description}
                  />
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default OneOff_Section2;
